export const cantSeeResultsFaqUrl =
    'https://help.totallymoney.com/en/articles/165176-why-isn-t-there-enough-information-in-my-file-and-why-can-t-i-see-any-credit-results'

export const eligibilityForCreditProductFaqUrl =
    'https://help.totallymoney.com/en/articles/165224-what-does-my-eligibility-for-a-credit-product-mean'

export const financialEssentialsFaqUrl =
    'https://help.totallymoney.com/en/collections/317647-your-financial-essentials'

export const loansFinancialEssentialsFaqUrl =
    'https://help.totallymoney.com/en/collections/317633-loans'

export const notEnoughInfoFaqUrl =
    'https://help.totallymoney.com/en/articles/165189-why-isn-t-there-enough-info-in-my-file-to-create-a-report'

export const whatIsPreapprovedFaqUrl =
    'https://help.totallymoney.com/en/articles/165228-what-does-pre-approved-mean'
